import { API, METHODS } from '../../constants';
import { fetchData } from '../common/apiCalling';
import { constructURL } from '../common';
import { isEmpty } from 'lodash';

export const updateUserVisitPageAPI = async ({ accountId, userId, path, data = {} }) => {
    const queryParams = {
        account_id: accountId,
        user_id: userId,
        path: path,
    };
    const newData = isEmpty(data) ? undefined : data;
    const url = constructURL(API.USER_PAGE_VISITS, queryParams);
    return fetchData({ body: newData, method: METHODS.PUT, url });
};

export const getUserReportExcelAPI = async () => {
    return fetchData({ method: METHODS.GET, url: API.USER_REPORT_EXCEL });
};

export const createUserLoginAPI = async ({ accountId }) => {
    const url = `${API.USER_LOGINS}/${accountId}`;
    return fetchData({ body: undefined, method: METHODS.POST, url });
};
